import { Card, Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useRef, useState } from 'react';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { TimelineDot } from '@mui/lab';
import componentConstants from '../../../core-utils/messages/componentConstants';
import {
  Button,
  CardComponent,
  ClaimDetail,
  Download,
  Table,
  SvgTable,
  ToggleGroup,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Layers } from '@mui/icons-material';
import properties from '../../../core-utils/properties';
import axios from 'axios';
import { ClaimDetailData } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import { useStores } from '../../../stores';

import { AlertColor as MuiColor } from '@mui/material/Alert';
import { medicalHistoryClaimIDMessage } from '../../../core-utils/messages/riskPatientDetailsConstants';
import Snackbar from '../../atoms/Snackbar';
import { downloadCSV } from '../../../core-utils/helper-utils/downloadPdfHelper';
export interface TimelineCardProps {
  claimId: string;
  memberID: string;
  diagnosis: string;
  provider: string;
  totalAmountPaid: string;
  icon: React.ReactNode;
  claimType: string;
  medication: string;
  avgRatevsCMS: string;
  totalRate: string;
  isBenchmarkPage?: boolean;
}

const MedicalTimelineCard: React.FC<TimelineCardProps> = ({
  claimId,
  memberID,
  diagnosis,
  provider,
  totalAmountPaid,
  icon,
  claimType,
  medication,
  avgRatevsCMS,
  totalRate,
  isBenchmarkPage = false,
}) => {
  const useStyles = makeStyles()({
    hide: {
      display: 'none',
    },
    root: {
      padding: '20px 24px 20px 24px',
      width: '844px',
      borderRadius: '8px',
      background: patientAccessTheme.palette.status.white,
      border: '1px solid' + patientAccessTheme.palette.grey[300],
      boxShadow: 'none',
    },
    icon: {
      backgroundColor: '#DEE5FF',
      marginBottom: '0px',
      boxShadow: 'none',
      width: '36px',
      height: '36px',
      marginTop: '6px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    text: {
      textDecoration: 'dashed',
      textDecorationLine: 'underline',
      textDecorationThickness: '0.5px',
      textUnderlineOffset: '5px',
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '1106px',
      height: '542px',
      padding: '24px 28px 40px 32px',
      backgroundColor: patientAccessTheme.palette.status.white,
      border: 'none !important',
      position: 'relative',
      outline: 'none',
    },
    button: {
      padding: '0px',
    },
    claimTableHeader: {
      height: '48px',
      backgroundColor: patientAccessTheme.palette.grey[400],
    },
    overallGridStyles: {
      width: '100%',
      marginRight: '150px',
    },
    ellipses: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      width: '140px',
      whiteSpace: 'nowrap',
      '&:hover': {
        overflow: 'visible',
        whiteSpace: 'normal',
        height: 'auto',
      },
    },
    downloadButtonGrid: {
      marginTop: '20px',
      marginBottom: '20px',
    },
    downloadCSVGrid: {
      marginRight: '10px',
    },
    tableHeader: {
      height: '48px',
      backgroundColor: patientAccessTheme.palette.grey[100],
      borderTop: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '&:first-child': {
        paddingLeft: '32px',
      },
      textAlign: 'left',
    },
    tableRow: {
      height: '48px',
      padding: '0px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '& td:first-child': {
        paddingLeft: '32px',
      },
      '& td': {
        padding: '1rem 0',
      },
    },
    headerText: {
      fontSize: '14px',
      fontWeight: 500,
      color: patientAccessTheme.palette.text.highemphasis,
    },
  });

  const { classes } = useStyles();
  const downloadAnchorRef = useRef<HTMLAnchorElement>(null);
  const [selectedTabName, setSelectedTabName] = React.useState<
    'left' | 'right'
  >('left');
  const [openModal, setOpenModal] = useState(false);
  const [claimDetail, setClaimDetail] = useState<ClaimDetailData>();
  const employerGroupStore = useStores().employerGroupStore;
  const {
    CLAIMS_ID,
    MEDICATION,
    PRIMARY_DIAGNOSIS,
    PROVIDER,
    TOTAL_AMOUNT_PAID,
    AVG_RATE_VS_CMS,
    TOTAL_RATE,
  } = componentConstants.MOLECULES.MEDICAL_HISTORY_TIMELINE;

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const getTruncatedText = (label: string) => {
    return (
      <Typography
        fontSize="14px"
        fontType="regular"
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        className={classes.ellipses}
      >
        {label}
      </Typography>
    );
  };
  const ClaimDetailColumn = ({
    label = '',
    value = '',
    valueProps = {},
    divider = false,
  }) => (
    <>
      {divider && (
        <Grid
          style={{
            borderRight: '1px solid #e0e0e0',
            margin: '0 20px',
            height: 'auto',
          }}
        />
      )}
      <Grid
        container
        style={{ maxWidth: '200px' }}
        sx={{
          flexDirection: 'column',
        }}
      >
        <Grid>
          <Typography
            fontSize="11px"
            lineHeight="22px"
            fontType="regular"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
          >
            {label}
          </Typography>
        </Grid>
        <Grid style={{ paddingTop: '4px' }}>
          <Typography
            fontSize="12px"
            lineHeight="160%"
            fontType="medium"
            textColor={patientAccessTheme.palette.text.highemphasis}
            {...valueProps}
          >
            {value}
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  const handleClaimId = async () => {
    await Promise.all([getClaimDetailAPI()]).then(() => {
      setOpenModal(true);
    });
  };

  const formatClaimIDBoxView = () => {
    const data: { label: string; value: any }[] = [];
    const outerColumnKeys = Object.keys(claimDetail?.ouputJsonForOuterColumn);
    const outerColumnValues = Object.values(
      claimDetail?.ouputJsonForOuterColumn,
    );
    for (let i = 0; i < outerColumnKeys.length; i++) {
      if (outerColumnValues[i] !== '' && outerColumnValues[i] !== '-') {
        data.push({
          label: outerColumnKeys[i],
          value: outerColumnValues[i],
        });
      }
    }

    return data;
  };

  const formatClaimIDTableDataView = () => {
    const arrayData: any = [];
    claimDetail?.lineItemsTable.forEach((lineItems) => {
      const line = JSON.parse(JSON.stringify(lineItems));
      arrayData.push(line);
    });
    return arrayData;
  };

  // const formatClaimIDTableDownloadDataView = () => {
  //   const arrayDownloadData: any = [];
  //   claimDetail?.lineItemsTable.forEach((lineItems) => {
  //     const concat = JSON.parse(
  //       JSON.stringify(claimDetail?.ouputJsonForOuterColumn),
  //     );
  //     Object.assign(concat, lineItems);
  //     arrayDownloadData.push(concat);
  //   });
  //   return arrayDownloadData;
  // };

  const formatClaimIDTableDownloadColumnView = () => {
    const values = Object.keys(claimDetail?.tableData[0]);
    const columnArray: {}[] = [];
    values.forEach((column: any) =>
      columnArray.push({
        id: column,
        Header: (
          <Typography className={classes.headerText} style={{ width: '180px' }}>
            {column}
          </Typography>
        ),
        Footer: column,
        accessor: column,
        accessorKey: column,
        Cell: ({ value }: any) => <>{getTruncatedText(value)}</>,
      }),
    );
    return columnArray;
  };

  const formatClaimIDTableColumnView = () => {
    const outerColumnKeys = Object.keys(claimDetail?.lineItemsTable[0]);
    return outerColumnKeys;
  };

  const getClaimDetailAPI = async () => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.claimDetail;
    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      claim_id: claimId,
    };

    await axios
      .post(url, requestBody)
      .then((response) => {
        response?.data?.data;

        setClaimDetail(response?.data?.data);
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 8000);
      });
  };

  const handleCloseButton = () => {
    setOpenModal(false);
  };

  const handleDownloadCSV = async (
    downloadAnchorRef: React.RefObject<HTMLAnchorElement | null>,
  ) => {
    const url =
      properties.aiqBaseUrl +
      properties.membersBaseUrl +
      properties.claimDetailsCsv;
    const requestBody = {
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      member_unique_id: memberID,
      claim_id: claimId,
    };

    downloadCSV(downloadAnchorRef, url, requestBody, claimId);
    handleOpenSnackBar(
      medicalHistoryClaimIDMessage.downloadCSVMessage,
      'info',
      5000,
    );
  };

  //TODO Need to implement in future

  // const handleDownloadExcel = (
  //   downloadAnchorRef: React.RefObject<HTMLAnchorElement>,
  // ) => {
  //   const url =
  //     properties.aiqBaseUrl +
  //     properties.membersBaseUrl +
  //     properties.claimDetailsExcel +
  //     '?eg_nid=' +
  //     employerGroupStore?.employerGroupResponseData?.eg_nid +
  //     '&member_unique_id=' +
  //     memberID +
  //     '&claim_id=' +
  //     claimId;
  //   downloadExcel(downloadAnchorRef, url, claimId);
  //   handleOpenSnackBar(
  //     medicalHistoryClaimIDMessage.downloadExcelMessage,
  //     'info',
  //     5000,
  //   );
  // };

  const getTypeHeader = (subType: string) => {
    switch (subType) {
      case 'Pharmacy':
        return 'Rx Claim Details';
      case 'Facility':
        return 'Medical Facility Claim Details';
      case 'Professional':
        return 'Medical Professional Claim Details';
      default:
        return 'NA';
    }
  };
  const closeButton = () => {
    return (
      <Button
        label={
          <Typography
            textColor={patientAccessTheme.palette.status.white}
            fontSize="12px"
            lineHeight="12px"
            fontType={'medium'}
          >
            {'Close'}
          </Typography>
        }
        variant="contained"
        color="primary"
        height="36px"
        width="180px"
        borderRadius="4px"
        className={classes.button}
        onClick={() => {
          setOpenModal(false);
        }}
      />
    );
  };

  return (
    <>
      <Card data-testid="timeline-card" className={classes.root}>
        <Grid
          container
          wrap="nowrap"
          spacing={2}
          sx={{
            alignItems: 'flex-start',
          }}
        >
          <Grid>
            <TimelineDot className={classes.icon}>{icon}</TimelineDot>
          </Grid>
          <Grid container spacing={2} style={{ gap: '1rem' }} size="grow">
            <Grid>
              <ClaimDetailColumn
                label={CLAIMS_ID}
                value={claimId}
                valueProps={{
                  fontSize: '12px',
                  textColor: patientAccessTheme.palette.primary[500],
                  className: classes.text,
                  cursor: 'pointer',
                  onClick: handleClaimId,
                }}
              />
            </Grid>
            <Grid>
              <ClaimDetailColumn
                divider
                label={claimType === 'rx' ? MEDICATION : PRIMARY_DIAGNOSIS}
                value={claimType === 'rx' ? medication : diagnosis}
              />
            </Grid>
            <Grid>
              <ClaimDetailColumn divider label={PROVIDER} value={provider} />
            </Grid>
            <Grid>
              <ClaimDetailColumn
                divider
                label={TOTAL_AMOUNT_PAID}
                value={totalAmountPaid}
                valueProps={{
                  fontSize: '14px',
                  fontType: 'semiBold',
                  textColor: patientAccessTheme.palette.primary.main,
                }}
              />
            </Grid>
            {isBenchmarkPage && (
              <>
                <Grid>
                  <ClaimDetailColumn
                    divider
                    label={TOTAL_RATE}
                    value={totalRate}
                    valueProps={{
                      fontSize: '14px',
                      fontType: 'semiBold',
                      textColor: patientAccessTheme.palette.primary.main,
                    }}
                  />
                </Grid>
                <Grid>
                  <ClaimDetailColumn
                    divider
                    label={AVG_RATE_VS_CMS}
                    value={avgRatevsCMS}
                    valueProps={{
                      fontSize: '14px',
                      fontType: 'semiBold',
                      textColor: patientAccessTheme.palette.primary.main,
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Card>
      <Grid>
        {openModal && (
          <>
            <Modal
              open={openModal}
              onClose={handleCloseButton}
              className={classes.modal}
            >
              <CardComponent
                title={getTypeHeader(claimDetail?.subType!) + ' - ' + claimId}
                width={'900px'}
                height={'643px'}
                body={
                  <>
                    {selectedTabName === 'left' ? (
                      <Grid style={{ marginTop: '20px' }}>
                        <ClaimDetail
                          data={formatClaimIDBoxView()}
                          cardWidth="875px"
                          cardHeight="600px"
                          claimRowData={formatClaimIDTableDataView()}
                          columnsValue={formatClaimIDTableColumnView()}
                        />
                        <Grid
                          style={{
                            display: 'flex',
                            justifyContent: 'right',
                            margin: '0px 24px 5px 0px',
                            position: 'absolute',
                            right: '0px',
                            bottom: '0px',
                          }}
                        >
                          {closeButton()}
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid>
                        <Grid style={{ height: '470px', marginTop: '20px' }}>
                          <Table
                            onHoverRowData={() => { }}
                            classNameForTableHeaderRowTop={classes.tableHeader}
                            classNameForTableDataRow={classes.tableRow}
                            classNameForTableHeader={classes.tableHeader}
                            columns={formatClaimIDTableDownloadColumnView()}
                            data={claimDetail?.tableData}
                            controlledPageIndex={0}
                            overallGridStyles={classes.overallGridStyles}
                            isManualPagination={true}
                            tableHeight="470px"
                          />
                        </Grid>
                        <Grid
                          container
                          direction="row"
                          className={classes.downloadButtonGrid}
                          sx={{
                            justifyContent: 'flex-end',
                            alignItems: 'flex-end',
                          }}
                        >
                          <Grid className={classes.downloadCSVGrid}>
                            <a
                              className={classes.hide}
                              href="empty"
                              ref={downloadAnchorRef}
                            />
                            <Button
                              label={medicalHistoryClaimIDMessage.downloadCSV}
                              variant="outlined"
                              color="primary"
                              height="33px"
                              width="180px"
                              borderRadius="4px"
                              startIcon={<Download />}
                              onClick={() =>
                                handleDownloadCSV(downloadAnchorRef)
                              }
                            />
                          </Grid>
                          {/* Need to implement in future so commenting now */}
                          {/* <Grid item>
                            <Button
                              label={medicalHistoryClaimIDMessage.downloadExcel}
                              variant="outlined"
                              color="primary"
                              height="33px"
                              width="180px"
                              borderRadius="4px"
                              startIcon={<Download />}
                              onClick={() =>
                                handleDownloadExcel(downloadAnchorRef)
                              }
                            />
                          </Grid> */}
                          <Grid style={{ marginLeft: '10px' }}>
                            {closeButton()}
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </>
                }
                topRightItem={
                  <ToggleGroup
                    leftValue={medicalHistoryClaimIDMessage.LEFT_VALUE}
                    rightValue={medicalHistoryClaimIDMessage.RIGHT_VALUE}
                    leftIcon={
                      <Layers style={{ height: '16px', width: '16px' }} />
                    }
                    rightIcon={
                      <SvgTable
                        style={{
                          height: '16px',
                          width: '16px',
                        }}
                      />
                    }
                    setSelectedToggle={setSelectedTabName}
                    showBothLabel={true}
                  />
                }
              />
            </Modal>
          </>
        )}
      </Grid>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
};

export default MedicalTimelineCard;
